const ROUTES = {
    home: "/",
    associates: "/associates",
    contact: "/contact",
    cookies: "/cookies",
    explore: "/explore",
    faq: "/faq",
    headlinePartners: "/headline-partners",
    headlinePartnersNatwest: "/headline-partners/natwest",
    headlinePartnersMnai: "/headline-partners/mnai",
    headlinePartnershsbc: "/headline-partners/hsbc",
    headlinePartnersSiliconValleyBank: "/headline-partners/silicon-valley-bank",
    headlinePartnersDwf: "/headline-sponsors/dwf",

    headlineSponsors: "/headline-sponsors",
    headlineSponsorsAmazonWebServices: "/headline-sponsors/amazon-web-services",
    headlineSponsorsGoldmanSachs: "/headline-sponsors/goldman-sachs",
    headlineSponsorsShoosmiths: "/headline-sponsors/shoosmiths",
    privacyPolicy: "/privacy-policy",
    reports: "/reports",
    reportsNarratives: "/reports/narratives",
    strategicPartners: "/strategic-partners",
    strategicPartnersMnai: "/strategic-partners/mnai",
    strategicPartnersSiliconValleyBank: "/strategic-partners/silicon-valley-bank",
    strategicSponsors: "/strategic-sponsors",
    strategicSponsorsShoosmiths: "/strategic-sponsors/shoosmiths",
    supporters: "/supporters",
    termsAndConditions: "/terms-and-conditions",
    whoWeAre: "/who-we-are",
    stories: "/stories",
    news: "/news",
};

export {
    ROUTES,
};
